import { Injectable } from '@angular/core';

import { AIDenoiserExtension, AIDenoiserProcessor } from 'agora-extension-ai-denoiser';
import AgoraRTC from 'agora-rtc-sdk-ng';

import { MessagingEnvironmentService } from '../../../core/services/messaging-environment.service';

@Injectable()
export class DenoiserService {
  denoiser: AIDenoiserExtension;
  processor: AIDenoiserProcessor;
  constructor(private env: MessagingEnvironmentService) {
    this.denoiser = new AIDenoiserExtension({ assetsPath: `${this.env.env.assetsNgxMessaging}/external` });
    AgoraRTC.registerExtensions([this.denoiser]);
    this.processor = this.denoiser.createProcessor();
  }
}
